// extracted by mini-css-extract-plugin
module.exports = {"component":"Details_component__1HCSk"};